const LIVE_API_URL = 'https://resort-booking-mu.vercel.app'

const isLocalBrowserHost = (): boolean => {
  if (typeof window === 'undefined') {
    return false
  }

  return window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
}

/**
 * Returns the base URL for all API calls.
 *
 * - Local dev in browser: empty string → Vite proxy forwards /api/* to Express on :3009
 * - Production/static deployments: default to the live Vercel API origin
 * - Explicit VITE_API_URL still overrides everything when provided
 */
export const getApiUrl = (): string => {
  const configuredApiUrl = import.meta.env.VITE_API_URL?.replace(/\/$/, '')

  if (configuredApiUrl) {
    return configuredApiUrl
  }

  if (isLocalBrowserHost()) {
    return ''
  }

  return LIVE_API_URL
}

const normalizeApiPath = (path: string): string => {
  return path.startsWith('/') ? path : `/${path}`
}

export const getApiAssetUrl = (path: string): string => {
  const baseUrl = getApiUrl()
  const normalizedPath = normalizeApiPath(path)
  return baseUrl ? `${baseUrl}${normalizedPath}` : normalizedPath
}

export const getPlaceholderImageUrl = (size = '400/300'): string => {
  return getApiAssetUrl(`/api/placeholder/${size}`)
}

export const normalizeApiAssetPath = (value: string): string => {
  const trimmedValue = value.trim()

  if (!trimmedValue || /^https?:\/\//i.test(trimmedValue) || trimmedValue.startsWith('data:') || trimmedValue.startsWith('blob:')) {
    return trimmedValue
  }

  if (trimmedValue.startsWith('/api/')) {
    return getApiAssetUrl(trimmedValue)
  }

  return trimmedValue
}
